import  {createContext, useState} from 'react'

const PortalContext = createContext<any>({});

export const PortalProvider = ({ children}) => {
    const [login, setLogin] = useState(false);
    const [register, setRegister] = useState(false);
    const [updatePassword, setupdatePassword] = useState(false);

    const openLogin = () => {
        setLogin(true);
        setRegister(false)
        setupdatePassword(false);
    };
    const openRegister = () => {
        setLogin(false);
        setRegister(true);
        setupdatePassword(false);
    };
    const openUpdatePassword = () => {
        setLogin(false);
        setRegister(false);
        setupdatePassword(true);
    };
    const closeAuthPortals = () => {
        setLogin(false);
        setRegister(false);
        setupdatePassword(false);
    }
    return (
        <PortalContext.Provider value={{
            loginPortal: login,
            updatePasswordPortal: updatePassword,
            registerPortal: register,
            openLogin,
            openRegister,
            openUpdatePassword,
            closeAuthPortals,
        }}>
            {children}
        </PortalContext.Provider>
    )
}
export default PortalContext;